import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const menuOptions = [
  'International',
  'Multiple Info',
  'District',
  'Region / Zone',
  'Club',
   'Member',
  'Dollar Rate',
  'DG Diary',
  'BAMA List',
  'Downloads',
  'Events',
  'Contact'
];

const MenuAdvertisement = () => {

  const [show, setShow] = useState(false);

  const [menu_name, setMenuName] = useState("");
  const [url, setUrl] = useState("");
  const [ad_image, set_ad_image] = useState(null);

  const [preview, setPreview] = useState(null);

  const [list, setList] = useState([]);
  const [adv_type, setAdvType] = useState("half");

  const [editId, setEditId] = useState(null);

  // const handleClose = () => {

  //   setShow(false);

  //   setMenuName("");
  //   setUrl("");
  //   set_ad_image(null);
  //   setPreview(null);

  //   setEditId(null);

  // };


  const handleClose = () => {
  setShow(false);
  setMenuName("");
  setAdvType("half"); // ✅ Reset to default
  setUrl("");
  set_ad_image(null);
  setPreview(null);
  setEditId(null);
};




  const getList = async () => {

    const dist = sessionStorage.getItem("dist");

    const res = await axios.post(
      "https://lionsdirectoryapi.emedha.in/notification/api/menu-advertise/list",
      { dist }
    );

    setList(res.data);

  };

  useEffect(() => {
    getList();
  }, []);

  const handleSubmit = async (e) => {

    e.preventDefault();

    const dist = sessionStorage.getItem("dist");

    const formData = new FormData();

    formData.append("file", ad_image);
    formData.append("menu_name", menu_name);
    formData.append("url", url);
    formData.append("adv_type", adv_type);
    formData.append("dist", dist);

    try {

      if (editId) {

        await axios.put(
          `https://lionsdirectoryapi.emedha.in/notification/api/menu-advertise/update/${editId}`,
          formData
        );

        alert("Updated Successfully");

      } else {

        await axios.post(
          "https://lionsdirectoryapi.emedha.in/notification/api/menu-advertise/create",
          formData
        );

        alert("Created Successfully");
      }

      handleClose();

      getList();

    } catch (err) {

      console.log(err);

      alert("Something went wrong");

    }

  };

  const deleteItem = async (id) => {

    if (!window.confirm("Delete this item?")) return;

    const dist = sessionStorage.getItem("dist");

    await axios.delete(
      `https://lionsdirectoryapi.emedha.in/notification/api/menu-advertise/delete/${id}`,
      {
        data: { dist }
      }
    );

    getList();

  };

  return (
    <>

      <Button variant="warning" onClick={() => setShow(true)}>
        Add Menu Advertisement
      </Button>

      <Modal show={show} onHide={handleClose} centered>

        <Modal.Header closeButton>
          <Modal.Title>
            {editId ? "Edit" : "Add"} Menu Advertisement
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <form onSubmit={handleSubmit}>

{/* ✅ Dynamic Recommendation Banner */}

<div className={`alert ${adv_type === 'full' ? 'alert-info' : 'alert-warning'}`}>
  <b>{adv_type === 'full' ? '📱 Full Page Mobile Ad Guidelines' : '🖼️ Half Page Banner Guidelines'}</b>
  <br /><br />
  {adv_type === 'full' ? (
    <>
      Recommended Size: <b>1080 × 1920 px</b> (or 720 × 1280 px)<br />
      Ratio: <b>9 : 16 (Portrait / Story view)</b><br />
      Best for full-screen popups, splash ads, and vertical posters.
    </>
  ) : (
    <>
      Recommended Size: <b>720 × 480 px</b> (or 400 × 300 px)<br />
      Ratio: <b>3 : 2 (Landscape)</b><br />
      Best for top banners inside lists and content screens.
    </>
  )}
</div>

{/* ✅ Select Advertisement Type */}
<label>Advertisement Type *</label>
<select
  className="form-control mb-3"
  value={adv_type}
  onChange={(e) => setAdvType(e.target.value)}
  required
>
  <option value="half">Half Page (Header Banner)</option>
  <option value="full">Full Page (Popup / Full Screen)</option>
</select>

            <label>Image *</label>

            <input
              type="file"
              className='form-control'
              accept='image/*'
              onChange={(e) => {

                const file = e.target.files[0];

                set_ad_image(file);

                if (file) {
                  setPreview(URL.createObjectURL(file));
                }

              }}
            />

         {preview && (
  <div style={{ marginTop: 15, textAlign: "center" }}>
    <img
      src={preview}
      alt="Preview"
      style={{
        width: adv_type === "full" ? "180px" : "100%",
        height: adv_type === "full" ? "320px" : "220px",
        objectFit: "cover",
        borderRadius: 16,
        border: "1.5px solid rgba(245,214,82,0.6)"
      }}
    />
  </div>
)}

            <br />

            <label>Select Menu *</label>

            <select
              className='form-control'
              value={menu_name}
              onChange={(e) => setMenuName(e.target.value)}
              required
            >

              <option value="">Select Menu</option>

              {
                menuOptions.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))
              }

            </select>

            <br />

            <label>URL (Optional)</label>

            <input
              type="text"
              className='form-control'
              placeholder='Website URL or WhatsApp Link'
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />

            <br />

            <button
              type='submit'
              className='btn btn-danger form-control'
            >
              {editId ? "Update" : "Submit"}
            </button>

          </form>

        </Modal.Body>

      </Modal>

      <div className='table-container mt-3'>

        <table className='table table-bordered'>

          <thead>

            <tr>
              <th>S.No</th>
              <th>Image</th>
              <th>Menu</th>
              <th>Type</th>
              <th>URL</th>
              <th>Actions</th>
            </tr>

          </thead>

          <tbody>

            {
              list.map((item, index) => (

                <tr key={item.id}>

                  <td>{index + 1}</td>

                  <td>
                    <img
                      src={item.image}
                      alt=""
                      width="150"
                      style={{
                        borderRadius: 10
                      }}
                    />
                  </td>

                  <td>{item.menu_name}</td>

                 
                  <td>
  <span className={`badge ${item.adv_type === 'full' ? 'bg-primary' : 'bg-warning text-dark'}`}>
    {item.adv_type === 'full' ? 'Full Page' : 'Half Page'}
  </span>
</td>

 <td>
                    {
                      item.url
                        ? <a href={item.url} target='_blank'>{item.url}</a>
                        : "-"
                    }
                  </td>

                  <td>
                    

                    <button
                      className='btn btn-primary me-2'
                      onClick={() => {

                        setEditId(item.id);

                        setMenuName(item.menu_name);
setAdvType(item.adv_type || "half"); // ✅ Populate current type
                        setUrl(item.url || "");

                        setPreview(item.image);

                        setShow(true);

                      }}
                    >
                      Edit
                    </button>

                    <button
                      className='btn btn-danger'
                      onClick={() => deleteItem(item.id)}
                    >
                      Delete
                    </button>

                  </td>

                </tr>

              ))
            }

          </tbody>

        </table>

      </div>

    </>
  )
}

export default MenuAdvertisement